import Sortable from "sortablejs";

//https://codepen.io/asprich/pen/LYdvaz
//https://codepen.io/jyloo/pen/GjbmLm

window.InitQuizDrag = function () {
  $(".session").each(function (index) {
    let thatQues = $(this);

    thatQues.find(".dragged-box").draggable({
      helper: "clone",
      zIndex: 10,
      scope: "demoBox",
      revertDuration: 10,

      revert: true,
      opacity: 0.7,

      //   helper: "clone",
      //  revert:true,
      start: function (event, ui) {
        $(this).css({
          opacity: 0
        });
      },
      stop: function (event, ui) {
        $(this).css({
          opacity: 1
        });
      }
    });

    thatQues.find(".dropped-area").each(function (index) {
      let droppableItem = $(this);
      droppableItem.droppable({
        scope: "demoBox",
        tolerance: "fit",
        revert: false,
        drop: function (e, ui) {
          if (ui.draggable.hasClass("dragged-box")) {
            var cloneImg = ui.draggable.clone(),
              cloneDragOpts = {
                //  containment: "parent"
              };
            // cloneImg.removeAttr("id");
            // cloneImg.removeClass();

            if (ui.draggable.hasClass("stop-repeat")) {
              $(this).find(".dragged-box").click();
            }

            cloneImg.addClass("cloned");

            cloneImg.detach().css({ top: 0, left: 0, opacity: 1 });

            if (!ui.draggable.hasClass("multiple")) {
              ui.draggable.addClass("dragged pointer-none");
            }

            // .draggable({

            // //  revert:false
            // });

            $(this).append(cloneImg);
            $(".cloned").on("click", function (event) {
              let that = $(this),
                that_id = that.data("id");

              $(this).remove();
              thatQues
                .find(".answers-to-drag-wrap .dragged-box[data-id=" + that_id + "]")
                .removeClass("dragged pointer-none");
            });
          }
        }
      });
    });
  });
  //sortable

  // gridDemo = document.getElementById('gridDemo'),
  // gridDemo = document.getElementsByClassName('d-flexaa')[0];

  // Grid demo

  // $(".theQuiz .sortableColumn").sortable({

  //   // items: '.dragged-itm',

  //   revert: true,
  //   opacity: 0.7,
  //   containment: 'parent'   ,

  //   helper: "clone",

  // });

  function renumber(itm, data) {
    // var count = 1;
    if (itm.find(".itm").length > 0) {
      var count = 0;
      itm.find(".itm").each(function () {
        $(this).find(".num").removeClass("d-none").text(data[count]);
        count++;
      });
    }
  }
  const boxes = document.querySelectorAll(".theQuiz .imgs-sortable-container ,.theQuiz .sortableColumn");

  for (const box of boxes) {
    var itm = $(box);
    var datasort = $(box).data("sort");

    //box.classList.add('bg-yellow');
    var sortable = new Sortable(box, {
      animation: 150,
      ghostClass: "gragged-itm",
      dragClass: "sortable-drag",
      onStart: function (/**Event*/ evt) {
        evt.oldIndex;
      },
      onMove: function (evt) {
        renumber(itm, datasort);
      },
      onChange: function (/**Event*/ evt) {
        evt.newIndex; // most likely why this event is used is to get the dragging element's current index
        renumber(itm, datasort);
      },

      // Element dragging ended
      onEnd: function (/**Event*/ evt) {
        //  renumber()
        var itemEl = evt.item; // dragged HTMLElement
        evt.to; // target list
        evt.from; // previous list
        evt.oldIndex; // element's old index within old parent
        evt.newIndex; // element's new index within new parent
        evt.oldDraggableIndex; // element's old index within old parent, only counting draggable elements
        evt.newDraggableIndex; // element's new index within new parent, only counting draggable elements
        evt.clone; // the clone element
        evt.pullMode; // when item is in another sortable: `"clone"` if cloning, `true` if moving
      }
    });
  }
};

//timer
window.startTimer = function (duration, display) {
  var timer = duration,
    minutes,
    inerval,
    seconds;
  var inerval = setInterval(function () {
    minutes = parseInt(timer / 60, 10);
    seconds = parseInt(timer % 60, 10);

    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    display.textContent = minutes + " : " + seconds;

    if (--timer < 0) {
      clearInterval(inerval);
      //  timer = duration;
    }
  }, 1000);
};
if ($("#counterTimer").length > 0) {
  let timetoCount = $("#counterTimer").attr("timer"),
    display = document.querySelector("#counterTimer");
  startTimer(timetoCount, display);
}

//initThePlugins
window.InitQuizDrag();

//start quiz-progress

window.quizProgress = function (index) {
  if ($(".quiz-progress").length > 0) {
    $(".quiz-progress .num").html(index);
    // let quesallnum = $(".allQuesNums").html();
    let quesallnum = $(".theQuiz .question").length;

    //console.log(quesallnum);
    let progress = (index * 100) / quesallnum;
    // console.log(progress);
    $(".quiz-progress .progress-bar").css("width", progress + "%");
    // $([document.documentElement, document.body]).animate({
    //     scrollTop: $(".quiz").offset().top - 140
    // }, 300);
  }
};
window.quizProgress(1);
//end quiz-progress

//nextBtn
$(".session")
  .eq(0)
  .addClass("active active-session")
  .find(".question")
  .eq(0)
  .removeClass("d-none")
  .addClass("active active-ques");
let activequesid = $(".active-ques").attr("id");
console.log(activequesid);
$(".ques-btn").attr("data-ques-id", activequesid);

let activequesindex = 1;
$("body").delegate(".nextQuesButton", "click", function () {
  $(".theQuiz").removeClass("readyForNext readyForshowtrueanswers").addClass("readyForSubmit");
  let activeques = $(".theQuiz").find(".session.active .question.active");
  let nextques = activeques.next(".question");
  // if mext question in the same question

  console.log("nextques.length", nextques.length);

  if (nextques.length == 0) {
  }
  // no next question in the session
  if (nextques.length < 1) {
    activeques = $(".theQuiz").find(".session.active");
    let nextSession = activeques.next(".session");
    nextques = nextSession.find(".question").eq(0);

    activeques.removeClass("active active-session").addClass("d-none").hide();
    nextSession.addClass("active active-session").removeClass("d-none").show();
  }
  // if next question in the session
  if (nextques.length > 0) {
    activeques.removeClass("active active-ques").addClass("d-none").hide();
  }
  $(".active-ques").removeClass("active-ques");
  nextques.addClass("active active-ques").removeClass("d-none").show();
  activequesindex++;

  activequesid = $(".active-ques").attr("id");
  $(".ques-btn").attr("data-ques-id", activequesid);

  window.quizProgress(activequesindex);
  $(".theQuiz").find(".count .num").html(activequesindex);
  $(".add-to-bookmark").removeClass("active");
});

//// for quiz sucess sucess

const Confettiful = function (el) {
  this.el = el;
  this.containerEl = null;

  this.confettiFrequency = 3;
  this.confettiColors = ["#EF2964", "#00C09D", "#2D87B0", "#48485E", "#EFFF1D"];
  this.confettiAnimations = ["slow", "medium", "fast"];

  this._setupElements();
  this._renderConfetti();
};

Confettiful.prototype._setupElements = function () {
  const containerEl = document.createElement("div");
  const elPosition = this.el.style.position;

  if (elPosition !== "relative" || elPosition !== "absolute") {
    // this.el.style.position = 'relative1';
  }

  containerEl.classList.add("confetti-container");

  this.el.appendChild(containerEl);

  this.containerEl = containerEl;
};

Confettiful.prototype._renderConfetti = function () {
  this.confettiInterval = setInterval(() => {
    const confettiEl = document.createElement("div");
    const confettiSize = Math.floor(Math.random() * 3) + 7 + "px";
    const confettiBackground = this.confettiColors[Math.floor(Math.random() * this.confettiColors.length)];
    const confettiLeft = Math.floor(Math.random() * this.el.offsetWidth) + "px";
    const confettiAnimation = this.confettiAnimations[Math.floor(Math.random() * this.confettiAnimations.length)];

    confettiEl.classList.add("confetti", "confetti--animation-" + confettiAnimation);
    confettiEl.style.left = confettiLeft;
    confettiEl.style.width = confettiSize;
    confettiEl.style.height = confettiSize;
    confettiEl.style.backgroundColor = confettiBackground;

    confettiEl.removeTimeout = setTimeout(function () {
      confettiEl.parentNode.removeChild(confettiEl);
    }, 3000);

    this.containerEl.appendChild(confettiEl);
  }, 25);
};
if (document.querySelector(".congratulations") !== null) {
  window.confettiful = new Confettiful(document.querySelector(".congratulations"));
}
